import React from 'react'
import noDataImg from '../../assets/images/nodata.svg';


const NoDatafound = ({ title, heading = "oops!" }) => {
    return (
        <div className="noData d-flex align-items-center justify-content-center flex-column">
            <img src={noDataImg} />

            <h3 className="mt-3">{title}</h3>
        </div>
    )
}

export default NoDatafound